import { useState, useRef, useEffect } from 'react'
import { BsFilterRight, BsSearch } from 'react-icons/bs'
import { FiChevronDown, FiStar } from 'react-icons/fi'
import './index.css'

const TopFilterBar = props => {
  const {
    categoryOptions,
    activeCategoryId,
    changeCategory,
    sortbyOptions,
    activeOptionId,
    changeSortby,
    ratingsList,
    activeRatingId,
    changeRating,
  } = props

  const [openDropdown, setOpenDropdown] = useState(null)
  const wrapperRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenDropdown(null)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])

  const toggleDropdown = (name) => {
    setOpenDropdown(prev => prev === name ? null : name)
  }

  const activeSortObj = sortbyOptions.find(s => s.optionId === activeOptionId)
  const activeRatingObj = ratingsList.find(r => r.ratingId === activeRatingId)

  const onEnterSearchInput = event => {
    if (event.key === 'Enter') {
      props.enterSearchInput()
    }
  }

  const onChangeSearchInput = event => {
    props.changeSearchInput(event.target.value)
  }

  return (
    <div className="top-filter-bar" ref={wrapperRef}>
      <div className="search-and-categories">
        <div className="top-search-input-container">
          <input
            type="search"
            className="top-search-input"
            placeholder="Search"
            value={props.searchInput}
            onChange={onChangeSearchInput}
            onKeyDown={onEnterSearchInput}
          />
          <BsSearch className="top-search-icon" />
        </div>
        
        <div className="categories-pill-strip">
          <button
            type="button"
            className={`category-pill ${activeCategoryId === '' ? 'active' : ''}`}
            onClick={() => changeCategory('')}
          >
            All
          </button>
          {categoryOptions.map(cat => (
            <button
              type="button"
              key={cat.categoryId}
              className={`category-pill ${activeCategoryId === cat.categoryId ? 'active' : ''}`}
              onClick={() => changeCategory(cat.categoryId)}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div className="filter-dropdowns">
        <div className="custom-dropdown-container">
          <button
            type="button"
            className={`dropdown-trigger ${activeRatingId ? 'has-value' : ''}`}
            onClick={() => toggleDropdown('rating')}
          >
            <FiStar className="dropdown-icon" />
            <span className="dropdown-label">
              {activeRatingObj ? `${activeRatingObj.ratingId} Stars & Up` : 'Rating'}
            </span>
            <FiChevronDown className={`chevron ${openDropdown === 'rating' ? 'up' : ''}`} />
          </button>
          
          {openDropdown === 'rating' && (
            <ul className="dropdown-menu">
              <li
                className={`dropdown-item ${activeRatingId === '' ? 'active' : ''}`}
                onClick={() => { changeRating(''); setOpenDropdown(null); }}
              >
                All Ratings
              </li>
              {ratingsList.map(rating => (
                <li
                  key={rating.ratingId}
                  className={`dropdown-item ${activeRatingId === rating.ratingId ? 'active' : ''}`}
                  onClick={() => { changeRating(rating.ratingId); setOpenDropdown(null); }}
                >
                  <img src={rating.imageUrl} alt={rating.ratingId} className="dropdown-rating-img" />
                  <span>& up</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="custom-dropdown-container">
          <button
            type="button"
            className="dropdown-trigger"
            onClick={() => toggleDropdown('sort')}
          >
            <BsFilterRight className="dropdown-icon sort-icon" />
            <span className="dropdown-label">
              {activeSortObj ? activeSortObj.displayText : 'Sort'}
            </span>
            <FiChevronDown className={`chevron ${openDropdown === 'sort' ? 'up' : ''}`} />
          </button>
          
          {openDropdown === 'sort' && (
            <ul className="dropdown-menu right-aligned">
              {sortbyOptions.map(option => (
                <li
                  key={option.optionId}
                  className={`dropdown-item ${activeOptionId === option.optionId ? 'active' : ''}`}
                  onClick={() => { changeSortby(option.optionId); setOpenDropdown(null); }}
                >
                  {option.displayText}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}

export default TopFilterBar
